import Vue from 'vue'
import Router from 'vue-router'

// 引入核心页面组件
// 认证模块
import Login from '../components/views/Login.vue' // 假设位于 src/views/Login.vue
import Register from '../components/views/Register.vue' // 假设位于 src/views/Register.vue

// 主体布局
import MainLayout from '../components/views/MainLayout.vue' // 假设位于 src/views/MainLayout.vue

// 设备管理模块 (嵌套路由的内容)
import DeviceBindingForm from '../components/views/DeviceBindingForm.vue' // 假设位于 src/views/DeviceBindingForm.vue
import DeviceListTable from '../components/views/DeviceListTable.vue' // 假设位于 src/views/DeviceListTable.vue
import DownloadPage from '../components/views/DownloadPage.vue'
import Config from '../components/views/Config'
import Member from '../components/views/Member'
import Pay from '../components/views/Pay'
Vue.use(Router)

/**
 * 路由配置说明:
 * 1. 登录和注册页面不要求认证 (meta: { requiresAuth: false })
 * 2. 设备管理页面要求认证 (meta: { requiresAuth: true })
 * 3. 使用 MainLayout 作为设备管理模块的父级布局
 */
let router = new Router({
  mode: 'hash', // 修改为 hash 模式
  routes: [
    // --- 认证路由 ---
    {
      path: '/',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false, title: '用户登录' }
    },
    {
      path: '/register',
      name: 'Register',
      component: Register,
      meta: { requiresAuth: false, title: '用户注册' }
    },
    // --- 主后台管理布局路由 ---
    {
      path: '/',
      component: MainLayout,
      meta: { requiresAuth: true, title: '系统主页' },
      children: [
        // 默认重定向到设备绑定页面
        // {
        //   path: '',
        //   // redirect: '/device/bind'
        //   redirect: '/login'
        // },
        // 设备 SN 绑定页面
        {
          path: 'device/bind',
          name: 'DeviceBinding',
          component: DeviceBindingForm,
          meta: { title: '设备 SN 绑定' }
        },
        // 设备信息查看页面
        {
          path: 'device/list',
          name: 'DeviceList',
          component: DeviceListTable,
          meta: { title: '设备信息查看' }
        },
        {
          path: 'device/download',
          name: 'DownloadPage',
          component: DownloadPage,
          meta: { title: 'APP下载' } // 可以添加 meta 信息方便在页面标题栏显示
        },
        {
          path: '/user/configpass',
          name: 'Config',
          component: Config,
          meta: { title: '修改密码' }
        },
        {
          path: '/device/member',
          name: 'member',
          component: Member,
          meta: {title: '水枪会员服务'}
        },
        {
          path: '/device/pay',
          name: 'pay',
          component: Pay,
          meta: {title: '二维码'}
        }
      ]
    }]
})

// const router = new Router({
//   mode: 'history', // 使用 history 模式，URL 更美观 (部署时需要后端配置支持)
//   base: process.env.BASE_URL,
//   routes
// })

// --- 全局前置守卫 (路由守卫) ---
// router.beforeEach((to, from, next) => {
//   // 假设通过检查 localStorage 中是否存在 'userToken' 来判断用户是否登录
//   const isAuthenticated = !!localStorage.getItem('token')
//
//   if (to.meta.requiresAuth) {
//     // 目标路由需要认证
//     if (isAuthenticated) {
//       next() // 已登录，放行
//     } else {
//       Vue.prototype.$message.warning('请先登录才能访问系统')
//       next({
//         path: '/',
//         query: { redirect: to.fullPath } // 记录目标路径，登录后跳转
//       })
//     }
//   } else {
//     // 目标路由不需要认证 (如登录、注册页)
//     if (isAuthenticated && (to.path === '/login' || to.path === '/register')) {
//       // 如果已登录，访问登录或注册页，则自动跳转到主页
//       next('/')
//     } else {
//       next() // 未登录，或访问其他无需认证页面，放行
//     }
//   }
// })
//
// // 可选：修改页面标题
// router.afterEach((to, from) => {
//   if (to.meta.title) {
//     document.title = `${to.meta.title} - 拓疆设备后台绑定系统`
//   }
// })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js